var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsuario(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "usuario") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.4,339.33c.48-12.38-.11-24.93,1.7-37.12,3.17-21.44,16.11-37.21,32.91-50,21.53-16.38,46.26-25.34,72.61-29.94,39.41-6.89,78.32-4.84,116.25,8.56,22.45,7.93,42.6,19.61,57.93,38.37a70.6,70.6,0,0,1,16.52,46.29c-.1,17.64-.12,35.29.05,52.93,0,4-1.42,6.62-5.28,6.89a129.63,129.63,0,0,1-16.84,0c-3.64-.24-5.12-2.68-5.08-6.54.15-17.34-.16-34.69.13-52,.23-13.36-4.58-24.47-13.61-34C303,269.4,287.2,261,269.94,255.54c-46.39-14.75-92.39-13.79-137.57,5C119.86,265.74,108.55,273,99.21,283c-8.83,9.48-13.58,20.43-13.36,33.63.28,17.19-.07,34.39.16,51.58.06,4.52-1.74,7-5.9,7.29a113.67,113.67,0,0,1-16-.18c-3.81-.31-5.45-2.76-5.35-6.83.23-9.72.08-19.44.08-29.16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205,30.72a87.85,87.85,0,1,1-88,87.64A87.73,87.73,0,0,1,205,30.72Zm-.1,27a60.86,60.86,0,1,0,60.8,60.68A60.74,60.74,0,0,0,204.94,57.7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuario);
export default __webpack_public_path__ + "static/media/usuario.64c017dc218dca5b59d6f529d2189cc2.svg";
export { ForwardRef as ReactComponent };